module.exports = __webpack_public_path__ + "img/AOB07615.1690b079.jpg";